import Vue from 'vue'
import store from '@vuex'
import FlowBlockingModalMixin from './flow-blocking-modal.mixin'

import { EventDispatcher } from '@js/events/event_dispatcher'
import { factorsService } from '@api/factors.service'
import { AuthStateHelper } from '@vuex/helpers/auth.helper'
import { WalletHelper } from '@js/helpers/wallet.helper'
import { i18n } from '@js/i18n'
import {ErrorFactory} from '@js/errors/factory'

const template = `
<md-dialog :md-active.sync="isOpened" :md-fullscreen="false" @md-closed="isOpened = false">
   <md-dialog-title>{{ i18n.mod_pwd_required() }}</md-dialog-title>

  <form novalidate @submit.prevent="onSubmit">
    <div class="app__dialog-inner">
      <input-field v-model="form.password"
                   v-validate="'required'"
                   id="signup-recovery-seed"
                   type="password"
                   name="password"
                   :autofocus="true"
                   :errorMessage="errorMessage('password')"
                   :data-vv-as="i18n.signup_password()"
                   :label="i18n.lbl_pwd()"
                   :togglePassword="true"
      />
    </div>

    <md-dialog-actions>
      <md-button class="md-primary" @click="close">{{ i18n.lbl_cancel() }}</md-button>
      <md-button class="md-primary" type="submit">{{ i18n.lbl_ok() }}</md-button>
    </md-dialog-actions>
  </form>
</md-dialog>
 `

/**
 *
 * @param onSubmit
 * @param opts
 * @param opts.salt
 * @param opts.kdf
 * @param opts.token
 * @param opts.keychainData
 * @param opts.factorId
 * @param opts.email
 *
 * @return {Promise<*>}
 */
export function createPasswordDialog (onSubmit, opts) {
  const keychainData = opts.keychainData
  const factorId = opts.factorId
  const token = opts.token
  const email = opts.email
  const salt = opts.salt
  const kdf = opts.kdf

  const passwordModal = document.createElement('div')
  document.querySelector('#app').appendChild(passwordModal)

  return new Promise((resolve, reject) => {
    const TFADialog = new Vue({
      template,
      store,
      mixins: [FlowBlockingModalMixin],
      data () {
        return {
          form: {
            password: ''
          }
        }
      },
      created () {
        this.setResolvers(resolve, reject)
      },
      methods: {
        async onSubmit () {
          if (!await this.isValid()) return
          if (!await AuthStateHelper.isPasswordCorrect(this.form.password)) {
            EventDispatcher.dispatchShowErrorEvent(i18n.mod_pwd_wrond())
          }
          const { walletKey } = WalletHelper.calculateWalletParams(this.form.password, email, salt, kdf)
          const signedToken = WalletHelper.signToken(token, keychainData, walletKey)
          this.disable()
          try {
            await factorsService.verifyFactor(factorId, token, signedToken)
          } catch (error) {
            console.error(error)
            EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error())
            return
          }

          this.resetResolvers()
          this.enable()
          this.removeElement()

          try {
            await this.resolvers.resolve(await onSubmit())
          } catch (error) {
            return this.resolvers.reject(error)
          }
        }
      },
      // TODO: this watcher doesn't work if placed in mixin, resolve why and remove code duplication from here and
      // tfa modal
      watch: {
        isOpened (val) {
          if (!val) {
            if (!this.isResolved) {
              this.resolvers.reject(ErrorFactory.getOTPCancelledError())
            }
            this.removeElement()
          }
        }
      }
    })
    TFADialog.$mount(passwordModal)
  })
}



// WEBPACK FOOTER //
// ./src/js/modals/password_dialog.modal.js